import styled from "styled-components";

export const ArtsFoundationHeroLandingDiv = styled.div`
  --color: ${(props) => props.backgroundColor || "var(--pink)"};
  width: var(--width);
  height: 570px;
  background-color: var(--color);
  position: relative;
  & > div:first-of-type {
    position: absolute;
    top: 133px;
    width: 100%;
    height: 420px;
    & + div {
      z-index: 2;
      top: 0;
      position: absolute;
      padding: 0 var(--outerMargin);
      pointer-events: none;
      & > svg {
        display: block;
      }
    }
  }
  & h1 {
    color: var(--purple);
    font-family: var(--flexFont);
    font-size: 140px;
    font-weight: 600;
    margin-top: 12px;
    line-height: 140px;
    pointer-events: none;
    user-select: none;
  }
  @media (max-width: 1439px) {
    & > div:first-of-type + div h1 {
      margin-top: 29px;
      font-size: 120px;
      line-height: 120px;
    }
  }
  @media (max-width: 1023px) {
    & > div:first-of-type + div h1 {
      margin-top: 49px;
      font-size: 90px;
      line-height: 100px;
    }
  }
  @media (max-width: 767px) {
    & > div:first-of-type + div h1 {
      margin-top: 25px;
      font-size: 42px;
      line-height: 42px;
    }
  }
`;
